var _rect, _path, _path2, _rect2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 120,
    viewBox: "0 0 80 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 120,
    fill: "url(#paint0_linear_332_4245)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 103C56.0163 103 69 83.5244 69 59.5C69 35.4756 56.0163 16 40 16C23.9837 16 11 35.4756 11 59.5C11 83.5244 23.9837 103 40 103ZM40 102C55.464 102 68 82.9721 68 59.5C68 36.0279 55.464 17 40 17C24.536 17 12 36.0279 12 59.5C12 82.9721 24.536 102 40 102Z",
    fill: "url(#paint1_linear_332_4245)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M70.75 59.5C70.75 72.0209 67.2918 83.3454 61.7137 91.5326C56.1347 99.7211 48.4533 104.75 40 104.75C31.5467 104.75 23.8653 99.7211 18.2863 91.5326C12.7082 83.3454 9.25 72.0209 9.25 59.5C9.25 46.9791 12.7082 35.6546 18.2863 27.4674C23.8653 19.2789 31.5467 14.25 40 14.25C48.4533 14.25 56.1347 19.2789 61.7137 27.4674C67.2918 35.6546 70.75 46.9791 70.75 59.5Z",
    stroke: "#F1D158",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 2.5,
    y: 2.5,
    width: 75,
    height: 115,
    rx: 1.5,
    stroke: "url(#paint2_linear_332_4245)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 89C5.11193 89 5 88.8881 5 88.75L5 31.25C5 31.1119 5.11193 31 5.25 31V31C5.38807 31 5.5 31.1119 5.5 31.25L5.5 88.75C5.5 88.8881 5.38807 89 5.25 89V89Z",
    fill: "#7E818D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.25 89C75.1119 89 75 88.8881 75 88.75V31.25C75 31.1119 75.1119 31 75.25 31V31C75.3881 31 75.5 31.1119 75.5 31.25V88.75C75.5 88.8881 75.3881 89 75.25 89V89Z",
    fill: "#7E818D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 5.25C52 5.38807 51.8881 5.5 51.75 5.5H28.25C28.1119 5.5 28 5.38807 28 5.25V5.25C28 5.11193 28.1119 5 28.25 5H51.75C51.8881 5 52 5.11193 52 5.25V5.25Z",
    fill: "#7E818D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 114.75C52 114.888 51.8881 115 51.75 115H28.25C28.1119 115 28 114.888 28 114.75V114.75C28 114.612 28.1119 114.5 28.25 114.5H51.75C51.8881 114.5 52 114.612 52 114.75V114.75Z",
    fill: "#7E818D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 44.5C32.2386 44.5 30 46.7386 30 49.5V64.5C30 70.0228 34.4772 74.5 40 74.5C45.5228 74.5 50 70.0228 50 64.5C50 58.9772 45.5228 54.5 40 54.5C38.1786 54.5 36.4709 54.987 35 55.8378V44.5ZM35 64.5C35 67.2614 37.2386 69.5 40 69.5C42.7614 69.5 45 67.2614 45 64.5C45 61.7386 42.7614 59.5 40 59.5C37.2386 59.5 35 61.7386 35 64.5Z",
    fill: "url(#paint3_linear_332_4245)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_332_4245",
    x1: 3.22859e-8,
    y1: -1,
    x2: 80,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09164E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_332_4245",
    x1: 4,
    y1: 4,
    x2: 76,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2D283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_332_4245",
    x1: 2,
    y1: 2,
    x2: 78.9427,
    y2: 117.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C6C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#918041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_332_4245",
    x1: 31.5,
    y1: 45,
    x2: 46,
    y2: 73.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6A46A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBook);
export default __webpack_public_path__ + "static/media/empty-book.efd525db63145d01a0e3d1ea1fe9ac3c.svg";
export { ForwardRef as ReactComponent };